<div class="item">
    <div class="center aligned content" data-i18n="portal.no-data">
        Keine Daten vorhanden.
    </div>
</div>
